module.exports = __webpack_public_path__ + "static/Unify-1-light-b5ef9155202ac8cde97b24e236d1d824.svg";